/**
 * `Badge` — etichetta compatta per stati/ruoli. Puramente presentazionale.
 */
import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral: '',
  primary: 'ui-badge--primary',
  success: 'ui-badge--success',
  warning: 'ui-badge--warning',
  danger: 'ui-badge--danger',
  info: 'ui-badge--info',
};

export function Badge({ tone = 'neutral', className, children }: BadgeProps) {
  const classes = ['ui-badge', TONE_CLASS[tone], className ?? '']
    .filter(Boolean)
    .join(' ');
  return <span className={classes}>{children}</span>;
}
